module.exports = __webpack_public_path__ + "media/assets/images/tree-781ef05801960f2c315482991dd18f22.svg";